import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from 'src/routes/PrivateRoute';
import { CalendarPage } from '../pages';

export const routes = (
  <Route
    path="/calendar"
    element={
      <PrivateRoute>
        <CalendarPage />
      </PrivateRoute>
    }
  />
);
